import React, { useState } from 'react';
import Constants from '../../App/Variables/Constants';
import axios from './axios';
import { spacing } from './const';
const TemplateBtn = ({ product_id, user_id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const duplicate_template = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(
        `${Constants.postUrls.templateProducts}${product_id}`, { user: user_id }
      );
      if (data.newProductId) {
        window.location.href = `/admin/viewer/${user_id}/${data.newProductId}`;
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <button
      disabled={isLoading}
      onClick={duplicate_template}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'white',
        outline: 'none',
        border: 0,
        height: 35,
        boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)',
        flex: 1,
        borderRadius: 7,
        marginLeft: spacing,
        background: '#e3e3e3',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: '#444'
        // color: '#444444',
      }}
    >
      <span
        style={{
          // paddingLeft: spacing,
          paddingRight: spacing,
          fontSize: 13,
          fontWeight: 400,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        Use this Template{isLoading ? ` ...` : ''}
      </span>
      {/* <TouchAppIcon fontSize='small' /> */}
      {/* {"this Template"}  */}
    </button>
  );
};

export default TemplateBtn;
